import type CreateJS from '@suntex.classic/createjs';

/**
 * for backwards compatibility with older fim-utils
 */
export function fixDynamicText({ yOffset = 0 } = {}) {
  const cache: Record<string, number> = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
  (createjs.Text.prototype as any)['_drawTextLine'] = function (
    this: CreateJS.Text,
    ctx: CanvasRenderingContext2D,
    text: string,
    y: number,
  ) {
    let offset = yOffset;

    // a dynamic text field created in Animate will have a name
    // a text field created in code will not
    if (this.name) {
      this.textBaseline = ctx.textBaseline = 'alphabetic';

      if (!(this.font in cache)) {
        const metrics = this.getMetrics() as { vOffset: number };
        cache[this.font] = metrics.vOffset;
      }

      offset = cache[this.font] ?? 0;
    }

    if (this.outline) {
      ctx.strokeText(text, 0, y - offset, this.maxWidth || 0xffff);
    } else {
      ctx.fillText(text, 0, y - offset, this.maxWidth || 0xffff);
    }
  };
}
